import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../../contexts/auth.context';
import PromoList from './PromoList';
import CreatePromoModal from './CreatePromoModal';
import { createPromo, getPromos } from '../../../apis/atlantis.api';

const Promos = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [promos, setPromos] = useState([]);
  const { auth } = useAuth();
  const authToken = useRef(auth?.idToken);

  useEffect(() => {
    authToken.current = auth?.idToken;
    fetchData();
  }, [auth?.idToken]);

  const fetchData = async () => {
    try {
      const items = await getPromos(authToken.current);
      // Show every promo with its status badge — atlantis creates promos
      // INACTIVE (the hourly reaper flips them ACTIVE inside their window),
      // so an ACTIVE-only filter hides freshly created promos and reads as
      // a failed create. ACTIVE first, then newest window first.
      const statusOrder = status => (status === 'ACTIVE' ? 0 : status === 'INACTIVE' ? 1 : 2);
      setPromos(
        [...(items ?? [])].sort(
          (a, b) =>
            statusOrder(a.status) - statusOrder(b.status) ||
            new Date(b.startTime) - new Date(a.startTime)
        )
      );
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleCreatePromo = async promoData => {
    await createPromo(promoData, authToken.current);
    await fetchData();
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center border-bottom">
        <div>
          <div className="game-micro">promo catalog</div>
          <h4 className="mb-0">Promo</h4>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <div className="btn-group me-2">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={() => setShowCreateModal(true)}
            >
              Create
            </button>
          </div>
        </div>
      </div>
      <div>
        <PromoList cardItems={promos} />
      </div>
      <CreatePromoModal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        onCreate={handleCreatePromo}
      />
    </div>
  );
};

export default Promos;
